import * as yup from 'yup'

export default yup.object().shape({
  password: yup.string().required('O campo Senha é requerido.')
})
